export const GROUP_OF_COMPANIES_MD = `
Our Sothebys.com website is provided by Sotheby's Inc, a US entity who is part of the Sotheby's group of companies. Depending on the auction or sale that you participate in, where you reside or the services that you request the other affiliates of Sotheby's from time to time, which includes those listed below, may also process your data.

If you interact with our .com website or an affiliate of Sotheby's, open an account, bid or transact in an auction or sale on that website or with such entity then, in addition to Sotheby's, the Sotheby's entity running the auction or sale will be the controller for that data. The name and contact details for this entity will be set out in your consignment agreement, private sale agreement, invoice or conditions of business for the auction or sale.  Such entities will be an affiliate of Sotheby's, which includes the entities listed below.

List of affiliate companies

Austria\\
Sotheby's Kunstauktionen GesmbH

Belgium\\
Sotheby's Belgium S.A.

Canada (RM)\\
RM Classic Cars Inc.

China\\
Sotheby's (Shanghai) Cultural Development Co., Ltd. \\
Sotheby's (Beijing) Commercial Co., Ltd. \\
Sotheby's (Shanghai) Auction Co., Ltd. \\
Sotheby's (Shanghai) E-commerce Co., Ltd.

Dubai\\
Sotheby's Art Services Limited

France\\
Sotheby's (France) SAS

Germany\\
Sotheby's Deutschland GmbH\\
RM Auctions Deutschland GmbH

Hong Kong\\
Sotheby's Hong Kong Limited

India\\
Sotheby's Art Services (India) Private Limited

Ireland\\
Sotheby's London (Irish branch)

Israel\\
Sotheby's Israel

Italy\\
Sotheby's Italia S.r.l\\
RM Auctions Italia S.r.l

Japan\\
Sotheby's Japan Ltd

Korea\\
Sotheby's Korea Limited

Monaco\\
Sotheby's Monaco S.A.M

Netherlands\\
Sotheby's Amsterdam B.V.

Singapore\\
Sotheby's (Singapore) Pte Ltd

Spain\\
Sotheby's y Asociados, S.A.

Sweden\\
Sotheby's Scandinavia Aktiebolag

Switzerland\\
Sotheby's AG\\
Sotheby's (Geneva Branch)\\
Sotheby's Diamonds, S.A\\
RM Auctions Suisse Sàrl

Taiwan\\
Sotheby's Taiwan Limited

UK\\
Sotheby's\\
Sotheby's Financial Services Limited\\
RM Auctions Limited

US\\
Sotheby's, Inc\\
Sotheby's Financial Services, Inc\\
RM Auctions, Inc.

US (wine)\\
Sothebys 72nd & York, Inc\\
York Storage, Inc


If you have any questions about the affiliates or this policy or would like to exercise any of your rights please contact privacycompliance@sothebys.com.

Effective Date: May 19, 2023
`;
